import {
  RegionPickerDropdownOption,
  REGIONS,
  UserDropdownOptionWithTranslationConfig,
  UserOptionsMenuItemsWithTranslationConfig,
} from '../types';

const USER_OPTIONS_MENU_ITEM_SAVED_ITEMS: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Saved',
    textId: 'media-ui-nav_menu_item_savedItems',
    url: '/portal/saved?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_INTERESTS: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'My Interests',
    textId: 'media-ui-nav_menu_item_interests',
    url: '/portal/your-content?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_NEWSLETTER: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Newsletters',
    textId: 'media-ui-nav_menu_item_newsletter',
    url: '/account/newsletters?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_WATCHLIST: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Watchlist',
    textId: 'media-ui-nav_menu_item_watchlist',
    url: '/markets/watchlist?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_CORPORATE_HUB: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'My Company Hub',
    textId: 'media-ui-nav_menu_item_corporateHub',
    url: '/subscriptions/group/hub?in_source=navi',
    badge: 'NEW',
  };

const USER_OPTIONS_MENU_ITEM_ACCOUNT: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Account',
    textId: 'media-ui-nav_menu_item_account',
    url: '/portal/account?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_SUBSCRIPTION: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Subscription',
    textId: 'media-ui-nav_menu_item_subscription',
    url: '/portal/subscription?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_BILLING: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Billing',
    textId: 'media-ui-nav_menu_item_billing',
    url: '/portal/billing?in_source=navi',
  };

const USER_OPTIONS_MENU_ITEM_HELP_CENTER: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Help Center',
    textId: 'media-ui-nav_menu_item_helpCenter',
    url: '/help?in_source=help-nav',
  };

export const USER_OPTIONS_MENU_ITEM_SIGN_OUT: UserDropdownOptionWithTranslationConfig =
  {
    defaultText: 'Sign Out',
    textId: 'media-ui-nav_menu_item_signOut',
    url: '/signout',
  };

export const USER_OPTIONS_MENU_ITEMS_LOGGED_IN: UserOptionsMenuItemsWithTranslationConfig =
  {
    interests: {
      defaultText: '',
      items: [
        USER_OPTIONS_MENU_ITEM_INTERESTS,
        USER_OPTIONS_MENU_ITEM_NEWSLETTER,
        USER_OPTIONS_MENU_ITEM_WATCHLIST,
      ],
    },
    settings: {
      defaultText: 'Settings',
      textId: 'media-ui-nav_menu_header_settings',
      items: [
        USER_OPTIONS_MENU_ITEM_ACCOUNT,
        USER_OPTIONS_MENU_ITEM_SUBSCRIPTION,
      ],
    },
    help: {
      defaultText: '',
      items: [
        USER_OPTIONS_MENU_ITEM_HELP_CENTER,
        USER_OPTIONS_MENU_ITEM_SIGN_OUT,
      ],
    },
  };

export const USER_OPTIONS_MENU_ITEMS_SUBSCRIBER: UserOptionsMenuItemsWithTranslationConfig =
  {
    interests: {
      defaultText: '',
      items: [
        USER_OPTIONS_MENU_ITEM_SAVED_ITEMS,
        USER_OPTIONS_MENU_ITEM_INTERESTS,
        USER_OPTIONS_MENU_ITEM_NEWSLETTER,
        USER_OPTIONS_MENU_ITEM_WATCHLIST,
      ],
    },
    settings: {
      defaultText: 'Settings',
      textId: 'media-ui-nav_menu_header_settings',
      items: [
        USER_OPTIONS_MENU_ITEM_ACCOUNT,
        USER_OPTIONS_MENU_ITEM_SUBSCRIPTION,
        USER_OPTIONS_MENU_ITEM_BILLING,
      ],
    },
    help: {
      defaultText: '',
      items: [
        USER_OPTIONS_MENU_ITEM_HELP_CENTER,
        USER_OPTIONS_MENU_ITEM_SIGN_OUT,
      ],
    },
  };

export const USER_OPTIONS_MENU_ITEMS_SUBSCRIBER_WITH_HUB_ACCESS: UserOptionsMenuItemsWithTranslationConfig =
  {
    ...USER_OPTIONS_MENU_ITEMS_SUBSCRIBER,
    interests: {
      ...USER_OPTIONS_MENU_ITEMS_SUBSCRIBER.interests,
      items: [
        ...USER_OPTIONS_MENU_ITEMS_SUBSCRIBER.interests.items,
        USER_OPTIONS_MENU_ITEM_CORPORATE_HUB,
      ],
    },
  };

export const REGIONAL_DATA: Record<REGIONS, RegionPickerDropdownOption> = {
  [REGIONS.US]: {
    value: 'AMER',
    text: 'US',
    url: '/',
  },
  [REGIONS.UK]: {
    value: 'UK',
    text: 'UK',
    switchEditionPrompt: 'Switch Editions',
    url: '/uk',
  },
  [REGIONS.CANADA]: {
    value: 'CANADA',
    text: 'Canada',
    url: '/canada',
  },
  [REGIONS.LATAM]: {
    value: 'LATAM',
    text: 'Latin America',
    url: '/latinamerica',
  },
  [REGIONS.EUROPE]: {
    value: 'EUR',
    text: 'Europe',
    url: '/europe',
  },
  [REGIONS.ASIA]: {
    value: 'APAC',
    text: 'Asia',
    url: '/asia',
  },
  [REGIONS.MIDDLE_EAST]: {
    value: 'MIDEAST',
    text: 'Middle East',
    url: '/middleeast',
  },
  [REGIONS.AFRICA]: {
    value: 'AFRICA',
    text: 'Africa',
    url: '/africa',
  },
  [REGIONS.JAPAN]: {
    value: 'JAPAN',
    text: '日本',
    url: 'https://www.bloomberg.co.jp',
  },
};

export const USER_OPTIONS_MENU_SUBSCRIBE_COPY_TEXT =
  'Subscribe to save and gift articles, and access exclusive newsletters';
export const EXP_PREF = 'exp_pref';
export const HELP_CENTER_URL = '/help';
export const WHAT_YOU_GET_URL = '/subscriptions/what-you-get';
export const MARKET_DATA_MENU_ID = 'markets';
export const MARKET_DATA_DROPDOWN_MENU_IDS = new Set<string>([
  'markets',
  '市場',
]);
export const MOBILE_NAV_WIDTH = 1087;
